/**
 * 表配置 - 5个数据表的列、筛选、表单字段配置
 */

export const TABLES_CONFIG = {
  // 专家授课
  expert_courses: {
    title: '专家授课',
    columns: [
      { key: 'id', label: 'ID', type: 'number' },
      { key: 'title', label: '标题', type: 'text' },
      { key: 'category', label: '类别', type: 'tag', options: { courseware: '课件分享', expert: '专家授课', blogger: '博主视频' } },
      { key: 'author', label: '作者', type: 'text' },
      { key: 'views', label: '浏览量', type: 'number' },
      { key: 'created_at', label: '创建时间', type: 'date' }
    ],
    filters: [
      { key: 'all', label: '全部' },
      { key: 'courseware', label: '课件分享' },
      { key: 'expert', label: '专家授课' },
      { key: 'blogger', label: '博主视频' }
    ],
    formFields: [
      { key: 'category', label: '类别', type: 'select', required: true, options: [{ value: 'courseware', label: '课件分享' }, { value: 'expert', label: '专家授课' }, { value: 'blogger', label: '博主视频' }] },
      { key: 'title', label: '标题', type: 'text', required: true },
      { key: 'author', label: '作者', type: 'text' },
      { key: 'cover', label: '封面图', type: 'text' },
      { key: 'file_url', label: '文件URL', type: 'text' },
      { key: 'video_url', label: '视频URL', type: 'text' },
      { key: 'description', label: '描述', type: 'textarea' }
    ]
  },

  // 专家文章
  expert_articles: {
    title: '专家文章',
    columns: [
      { key: 'id', label: 'ID', type: 'number' },
      { key: 'title', label: '标题', type: 'text' },
      { key: 'source', label: '来源', type: 'tag', options: { yaogu: '药谷' } },
      { key: 'publish_date', label: '发布日期', type: 'date' },
      { key: 'author', label: '作者', type: 'text' }
    ],
    filters: [
      { key: 'all', label: '全部' },
      { key: 'yaogu', label: '药谷' }
    ],
    formFields: [
      { key: 'source', label: '来源', type: 'text', required: true },
      { key: 'title', label: '标题', type: 'text', required: true },
      { key: 'url', label: '原文链接', type: 'text', required: true },
      { key: 'author', label: '作者', type: 'text' },
      { key: 'publish_date', label: '发布日期', type: 'date' }
    ]
  },

  // 知识分享
  knowledge_shares: {
    title: '知识分享',
    columns: [
      { key: 'id', label: 'ID', type: 'number' },
      { key: 'title', label: '标题', type: 'text' },
      { key: 'type', label: '类型', type: 'tag', options: { article: '文章', document: '文档', link: '链接' } },
      { key: 'category', label: '分类', type: 'tag', options: { tech: '技术', share: '分享', other: '其他' } },
      { key: 'status', label: '状态', type: 'tag', options: { pending: '待审核', approved: '已通过', rejected: '已拒绝' } },
      { key: 'created_at', label: '创建时间', type: 'date' }
    ],
    filters: [
      { key: 'all', label: '全部' },
      { key: 'pending', label: '待审核' },
      { key: 'approved', label: '已通过' }
    ],
    formFields: [
      { key: 'type', label: '类型', type: 'select', required: true, options: [{ value: 'article', label: '文章' }, { value: 'document', label: '文档' }, { value: 'link', label: '链接' }] },
      { key: 'category', label: '分类', type: 'select', required: true, options: [{ value: 'tech', label: '技术' }, { value: 'share', label: '分享' }, { value: 'other', label: '其他' }] },
      { key: 'title', label: '标题', type: 'text', required: true },
      { key: 'description', label: '描述', type: 'textarea' },
      { key: 'file_url', label: '文件URL', type: 'text' },
      { key: 'link_url', label: '链接URL', type: 'text' },
      { key: 'status', label: '状态', type: 'select', options: [{ value: 'pending', label: '待审核' }, { value: 'approved', label: '已通过' }, { value: 'rejected', label: '已拒绝' }] }
    ]
  },

  // 知识更新
  knowledge_updates: {
    title: '知识更新',
    columns: [
      { key: 'id', label: 'ID', type: 'number' },
      { key: 'description', label: '描述', type: 'text' },
      { key: 'update_date', label: '更新日期', type: 'date' },
      { key: 'created_at', label: '创建时间', type: 'date' }
    ],
    filters: [],
    formFields: [
      { key: 'update_date', label: '更新日期', type: 'date', required: true },
      { key: 'description', label: '描述', type: 'textarea', required: true }
    ]
  },

  // 技术文档
  tech_documents: {
    title: '技术文档',
    columns: [
      { key: 'id', label: 'ID', type: 'number' },
      { key: 'title', label: '标题', type: 'text' },
      { key: 'category', label: '类别', type: 'tag', options: { tech: '技术文档', policy: '政策法规' } },
      { key: 'file_name', label: '文件名', type: 'text' },
      { key: 'download_count', label: '下载次数', type: 'number' },
      { key: 'status', label: '状态', type: 'tag', options: { active: '正常', disabled: '禁用' } },
      { key: 'created_at', label: '创建时间', type: 'date' }
    ],
    filters: [
      { key: 'all', label: '全部' },
      { key: 'tech', label: '技术文档' },
      { key: 'policy', label: '政策法规' }
    ],
    formFields: [
      { key: 'category', label: '类别', type: 'select', required: true, options: [{ value: 'tech', label: '技术文档' }, { value: 'policy', label: '政策法规' }] },
      { key: 'title', label: '标题', type: 'text', required: true },
      { key: 'description', label: '描述', type: 'textarea' },
      { key: 'file_url', label: '文件URL', type: 'text', required: true },
      { key: 'file_name', label: '文件名', type: 'text' },
      { key: 'file_size', label: '文件大小', type: 'text' },
      { key: 'file_type', label: '文件类型', type: 'text' },
      { key: 'status', label: '状态', type: 'select', options: [{ value: 'active', label: '正常' }, { value: 'disabled', label: '禁用' }] }
    ]
  },

  // 市场价格
  market_prices: {
    title: '市场价格管理',
    columns: [
      { key: 'id', label: 'ID' },
      { key: 'herb_name', label: '药材名' },
      { key: 'market', label: '市场' },
      { key: 'price', label: '价格' },
      { key: 'unit', label: '单位' },
      { key: 'is_recommended', label: '推荐', type: 'switch', editable: true },
      { key: 'created_at', label: '时间', type: 'date' }
    ],
    filters: [
      { key: 'all', label: '全部' },
      { key: 'recommended', label: '推荐药材' }
    ],
    formFields: [
      { key: 'herb_name', label: '药材名', type: 'text', required: true },
      { key: 'market', label: '市场', type: 'text', required: true },
      { key: 'price', label: '价格', type: 'number', required: true },
      { key: 'unit', label: '单位', type: 'text', required: true },
      { key: 'is_recommended', label: '推荐', type: 'switch' }
    ]
  },

  // 产地价格
  origin_prices: {
    title: '产地价格管理',
    columns: [
      { key: 'id', label: 'ID' },
      { key: 'herb_name', label: '药材名' },
      { key: 'province', label: '产地' },
      { key: 'price', label: '价格' },
      { key: 'unit', label: '单位' },
      { key: 'is_recommended', label: '推荐', type: 'switch', editable: true },
      { key: 'created_at', label: '时间', type: 'date' }
    ],
    filters: [
      { key: 'all', label: '全部' },
      { key: 'recommended', label: '推荐药材' }
    ],
    formFields: [
      { key: 'herb_name', label: '药材名', type: 'text', required: true },
      { key: 'province', label: '产地', type: 'text', required: true },
      { key: 'price', label: '价格', type: 'number', required: true },
      { key: 'unit', label: '单位', type: 'text', required: true },
      { key: 'is_recommended', label: '推荐', type: 'switch' }
    ]
  }
}

export default TABLES_CONFIG
